import Vue from "vue";
import VueRouter from "vue-router";
import { store } from "./store/store";

import Home from "./pages/Home";
import Dashboard from "./pages/dashboard/Dashboard";
import RealTimeMonitor from "./pages/realTimeMonitor/RealTimeMonitor";
import Employees from "./pages/employees/Employees";
import Operations from "./pages/operations/Operations";
// Reports
import Reports from "./pages/reports/Reports";
import ShiftReport from "./pages/reports/ShiftReport";
import VerticalFirstInLastOutReport from "./pages/reports/VerticalFirstInLastOutReport";
// Payroll Management
import PayrollManagement from "./pages/payrollManagement/PayrollManagement";
import PayrollShiftManagement from "./pages/payrollManagement/PayrollShiftManagement";
// Shift Management
import ShiftManagement from "./pages/shiftManagement/ShiftManagement";
// Visitors
import Visitors from "./pages/visitors/Visitors";
import VisitorCards from "./pages/visitorCards/VisitorCards";
import VisitorReports from "./pages/visitorReports/VisitorReports";
// License Plate Recognition
import LicensePlateRecognition from "./pages/licensePlateRecognition/licensePlateRecognition.vue";
// Food Groups
import FoodGroups from "./pages/foodGroups/FoodGroups";
import FoodGroupOperations from "./pages/foodGroupOperations/FoodGroupOperations";
import FoodGroupReports from "./pages/foodGroupReports/FoodGroupReports";
import RetailSale from "./pages/retailSale/retailSale";

// Student Dormitory
import BuildDefinitions from "./pages/buildings/BuildDefinitions";
import BuildDefinitionsTest from "./pages/buildings/BuildDefinitionsTest.vue";

//Guard Tour
import Guards from "./pages/guardTour/Guards";
import AreasGuardTour from "./pages/guardTour/Areas";
import ControlPoints from "./pages/guardTour/ControlPoints";
import GuardTours from "./pages/guardTour/GuardTours";
import GuardTourReports from "./pages/guardTour/GuardTourReports";
import GuardTourIncidentReports from "./pages/guardTour/GuardIncidentReport.vue";

//Inventory Management
import InventoryCategories from "./pages/inventoryManagement/InventoryCategories.vue";
import InventoryWarehouse from "./pages/inventoryManagement/InventoryWarehouse.vue";
import InventoryFields from "./pages/inventoryManagement/InventoryFields.vue";
import Inventories from "./pages/inventoryManagement/Inventories.vue";

// Definitions
import CardDesigns from "./pages/cardDesign/CardDesign";
import ExtraFields from "./pages/extraFields/ExtraFields";
import DocumentDefinitions from "./pages/documentDefinitions/documentDefinitions.vue";
import Departments from "./pages/departments/Departments";
import AccessGroups from "./pages/accessGroups/AccessGroups";
import Shifts from "./pages/shifts/Shifts";
import OvertimeSettings from "./pages/overtimeSettings/OvertimeSettings";
import Allowences from "./pages/allowences/Allowences";
import AnnualPermits from "./pages/annualPermits/AnnualPermits";
import ScenarioList from "./pages/scenarios/ScenarioList";
import ScenarioDetails from "./pages/scenarios/ScenarioDetails";
import TimeZone from "./pages/timeZones/TimeZone";
import Devices from "./pages/devices/Devices";
import DeviceOperations from "./pages/deviceOperations/DeviceOperations";
import WorkPlaceDefinitions from "./pages/workPlaceDefinitions/workPlaceDefinitions";
// Settings
import CompanySettings from "./pages/companySettings/CompanySettings";
import ShiftSettings from "./pages/shiftManagement/ShiftSettings";
import Users from "./pages/users/Users";
import MyProfile from "./pages/users/MyProfile";
import UserAuthorityGroups from "./pages/userAuthorityGroups/UserAuthorityGroups";
import MailSmsSettings from "./pages/mailSmsSettings/MailSmsSettings";
import UserLogs from "./pages/userLogs/UserLogs";
import PayrollTypes from "./pages/payrollTypes/PayrollTypes";
import MonthlyPayrollTables from "./pages/monthlyPayrollTables/MonthlyPayrollTables";
import Integration from "./pages/integration/Integration";
import AppSettings from "./pages/AppSettings/AppSettings";
import Help from "./pages/help/Help";
import AppAbout from "./pages/appAbout/AppAbout";
// Login";
import SignIn from "./auth/SignIn";
import SignUp from "./auth/SignUp";

Vue.use(VueRouter)
export const router = new VueRouter({

    routes: [
        {
            path: '', component: Home, children: [
                { path: '', component: Dashboard },
                { path: 'dashboard', component: Dashboard },
                { path: 'real-time-monitor', component: RealTimeMonitor },
                { path: 'employees', component: Employees },
                { path: 'operations', component: Operations },
                { path: 'reports', component: Reports },
                { path: 'shift-report', component: ShiftReport },
                { path: 'vertical-first-in-last-out-report', component: VerticalFirstInLastOutReport },
                { path: 'payroll-management', component: PayrollShiftManagement },
                { path: 'shift-management', component: ShiftManagement },
                { path: 'visitors', component: Visitors },
                { path: 'visitor-cards', component: VisitorCards },
                { path: 'visitor-reports', component: VisitorReports },
                { path: 'license-plate-recognition', component: LicensePlateRecognition },
                { path: 'retail-sale', component: RetailSale },
                { path: 'food-groups', component: FoodGroups },
                { path: 'food-group-operations', component: FoodGroupOperations },
                { path: 'food-group-reports', component: FoodGroupReports },
                { path: 'build-definitions', component: BuildDefinitions},
                { path: 'build-definitions-test', component: BuildDefinitionsTest},
                { path: 'guards', component: Guards},
                { path: 'guard-tour-area', component: AreasGuardTour},
                { path: 'control-points', component: ControlPoints},
                { path: 'guard-tours', component: GuardTours},
                { path: 'guard-tour-reports', component: GuardTourReports},
                { path: 'guard-tour-incident-reports', component: GuardTourIncidentReports},
                { path: 'card-designs', component: CardDesigns},
                { path: 'extra-fields', component: ExtraFields},
                { path: 'departments', component: Departments },
                { path: 'access-groups', component: AccessGroups },
                { path: 'shifts', component: Shifts },
                { path: 'allowences', component: Allowences },
                { path: 'work-place-definitions', component: WorkPlaceDefinitions },
                { path: 'inventory-categories', component: InventoryCategories },
                { path: 'inventory-warehouses', component: InventoryWarehouse },
                { path: 'inventory-fields', component: InventoryFields },
                { path: 'inventories', component: Inventories },
                { path: 'document-definitions', component: DocumentDefinitions },
                { path: 'annual-permits', component: AnnualPermits },
                { path: 'overtime-settings', component: OvertimeSettings },
                { path: 'scenario-list', component: ScenarioList },
                { path: 'new-scenario', component: ScenarioDetails },
                { name: 'scenario-details', path: '/scenario-details/:id', component: ScenarioDetails },
                { path: 'timezones', component: TimeZone },
                { path: 'devices', component: Devices },
                { path: 'device-operations', component: DeviceOperations },
                { path: 'company-settings', component: CompanySettings },
                { path: 'shift-settings', component: ShiftSettings },
                { path: 'users', component: Users },
                { path: 'my-profile', component: MyProfile },
                { path: 'user-authority-groups', component: UserAuthorityGroups },
                { path: 'mail-sms-settings', component: MailSmsSettings },
                { path: 'user-logs', component: UserLogs },
                { path: 'payroll-types', component: PayrollTypes },
                { path: 'monthly-payroll-tables', component: MonthlyPayrollTables },
                { path: 'integration', component: Integration },
                { path: 'app-settings', component: AppSettings },
                { path: 'help', component: Help },
                { path: 'app-about', component: AppAbout },
            ]
        },
        {
            path: '/auth', component: SignIn, children: [
                { path: '', component: SignIn },
                { path: '/signup', component: SignUp },
                { path: '/login', component: SignIn },
            ]
        },
        //{
        //path: '/redirect',
        //redirect: (to) => {
        //  var currentUrl = window.location.pathname;
        //console.log(currentUrl);
        //window.location.href = currentUrl;
        //return '/dashboard' // not important since redirecting
        //}
        //},
        { path: "*", redirect: "/login" } // Wildcard : tanımsız yönlendirmeler
    ],
    mode: 'history' //hash : Default
});



// WEBPACK FOOTER //
// ./src/router.js